import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLanguage } from '../Contexts/LanguageContext';
import TranslatedText from './TranslatedText';
import CloseIcon from '../Elements/Icon/assets/close-thin.component.svg';
import strings from '../strings';

const Modal = ({icon: Icon, data, onCloseModal}) => {
    const { language } = useLanguage();
    const [animationClass, setAnimationClass] = useState('is-opening');
    const contentRef = useRef(null);

    /**
     * The double rAF guarantees:
     *
     * First rAF: The browser has committed the initial frame (with is-opening styles — opacity 0, scale 0.95)
     * Second rAF: Now safe to switch to is-open — the browser has a "before" state to transition from
     */
    useEffect(() => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setAnimationClass('is-open');
            });
        });
    }, []);

    const handleClose = useCallback(() => {
        setAnimationClass('is-closing');
        const el = contentRef.current;
        if (el) {
            el.addEventListener('transitionend', () => onCloseModal(), { once: true });
        } else {
            onCloseModal();
        }
    }, [onCloseModal]);

    return (
        <div 
            className={`modal ${animationClass}`}
            role="dialog" 
            aria-modal="true"
            aria-labelledby="modal-label"
            aria-describedby="modal-description"
        >
            <div className="modal__backdrop" onClick={handleClose} />
            <div className="modal__content" ref={contentRef}>
                <button className="modal__close-button" aria-label={strings.MODAL_CLOSE_ARIA_LABEL[language]} onClick={handleClose}>
                    <CloseIcon />
                </button>
                <div className="modal__header">
                    <Icon />
                    <h2 id="modal-label" className="modal__header__label"><TranslatedText item={data.menuItemLabel} /></h2>
                </div>
                <div className="modal__text-content">
                    <p className="heading-medium modal__title"><TranslatedText item={data.menuItemModalTitle} /></p>
                    <p id="modal-description" className="modal__text"><TranslatedText item={data.menuItemModalText} /></p>
                </div>
            </div>
        </div>
    );
}

export default Modal;